import { RaffleDrawContextStateType, RaffleDrawContextValueType, RaffleDrawProviderProps } from '@src/lib/types/create-raffle-draw';
import { useInputHelper } from '@src/utils/inputs-helper';
import { ChangeEvent, createContext, useContext, useState } from 'react';

const initialState: RaffleDrawContextStateType = {
  page: 0,
  order: 'desc',
  orderBy: 'drawAt',
  rowsPerPage: 10,
  editDetails: {},
  openCreate: false,
  search: "",
  subject: "",
}

export const RaffleDrawContext = createContext<RaffleDrawContextValueType>({} as RaffleDrawContextValueType);

const RaffleDrawProvider = ({ children }: RaffleDrawProviderProps) => {
  const [error] = useState({});
  const [ viewWinners, setViewWinners ] = useState<any>({});
  const { state, onDispatch } = useInputHelper(initialState);

  const handlePageChange = (event: unknown, newPage: number) => {
    onDispatch('page')(newPage);
  }

  const handleRequestSort = (property: string) => {
    const isAsc = state.orderBy === property && state.order === 'asc';
    onDispatch('order')(isAsc ? 'desc' : 'asc');
    onDispatch('orderBy')(property);
  };

  const handleRowsPerPageChange = (event: ChangeEvent<HTMLInputElement>) => {
    onDispatch('rowsPerPage')(event.target.value);
  }

  const openEdit = (item: any) => {
    onDispatch('editDetails')(item);
  }

  const openCreate = () => {
    onDispatch('openCreate')(!state.openCreate);
  }

  const value = {
    state,
    error,
    onDispatch,
    handlePageChange,
    handleRequestSort,
    handleRowsPerPageChange,
    openEdit,
    openCreate,
    viewWinners, setViewWinners
  };

  return (
    <RaffleDrawContext.Provider value={value}>
      {children}
    </RaffleDrawContext.Provider>
  );
};

export const useRaffleDrawContext = () => {
  return useContext(RaffleDrawContext);
}

export default RaffleDrawProvider;
